// extracted by mini-css-extract-plugin
export default {"nodeTypeTag":"NodeTypeTag__nodeTypeTag___ZfwfL"};